var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"progress progress-striped"},[_c('div',{staticClass:"progress-bar",class:{ pauseBar: _vm.pauseBarAnimation }})])])}
var staticRenderFns = []

export { render, staticRenderFns }